import googleanalytics from './googleanalytics';

export interface Analytics<T>{
    initialize:(conf:T)=>void;
    pageView:(conf:T)=>void;
}

export const AnalyticsObj:Analytics<any> = googleanalytics;